class RewardsProductPoints extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Format the points display
    const productPrice = parseInt(this.dataset.productPrice);
    const pointsElement = this.querySelector('.rewards-product__points-value');

    if (productPrice && pointsElement) {
      // Format the number with commas
      const formattedPoints = productPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      pointsElement.textContent = `${formattedPoints} POINTS`;
    }
  }
}

// Register the custom element
customElements.define('rewards-product-points', RewardsProductPoints);